import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Layout } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import Logo from '../../assets/images/Logo-menu.png';
import LogoCollapsed from '../../assets/images/Logo-menu-collapsed.png';
import { useLayoutCollapse } from './useLayoutCollapse';
import { AdminNavMenu } from './AdminNavMenu';
import LayoutStructure from './LayoutStructure';
import version from '../../../package.json';

const { Footer } = Layout;

const HEADER_HEIGHT = 88;

const StyledLayout = styled.div`
  height: 100vh;
  height: 100dvh;
`;

const StyledSider = styled.div`
  height: 100vh;
  height: 100dvh;
  z-index: 10;
  box-shadow: 4px 0px 8px 0px rgba(9, 9, 9, 0.1);
  overflow-x: hidden;
  position: fixed;
  left: 0;
  border-radius: 0px 16px 16px 0px;
`;

const LogoDiv = styled.div`
  position: relative;
  height: 64px;
  padding-left: 0;
  overflow: hidden;
  line-height: 64px;
  transition: all 0.3s;
  z-index: 900;
  display: flex;
  justify-content: center;
  img {
    display: inline-block;
    height: 56px;
    vertical-align: middle;
  }
`;

const StyledContent = styled.div`
  margin: 0 0 0 ${(props) => props.siderWidth}px;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  background: var(--bodyBackground);
  transition: margin-left 0.2s;
`;

const StyledFooter = styled.footer`
  padding: 10px 10px calc(10px + env(safe-area-inset-bottom));
  text-align: center;
  font-size: 12px;
  background-color: var(--bodyBackground);
  color: var(--dimGray);

  a {
    color: var(--ds-cambridge-dark);
  }
`;

/**
 * AdminLayout component.
 * @component
 * @param {React.ElementType} NavMenuComponent - Nav menu to render (defaults to AdminNavMenu).
 * @returns {JSX.Element} - The AdminLayout component.
 */
export const AdminLayout = ({ NavMenuComponent }) => {
  const { t } = useTranslation();
  const { collapsed, setCollapsed, collapseWidth, siderWidth, onCollapse } =
    useLayoutCollapse();
  const { version: currentVersion } = version;

  return (
    <LayoutStructure
      StyledLayoutComponent={StyledLayout}
      StyledSiderComponent={StyledSider}
      LogoDivComponent={LogoDiv}
      StyledContentComponent={StyledContent}
      logo={Logo}
      logoCollapsed={LogoCollapsed}
      NavMenuComponent={NavMenuComponent}
      collapsed={collapsed}
      setCollapsed={setCollapsed}
      collapseWidth={collapseWidth}
      onCollapse={onCollapse}
      siderWidth={siderWidth}
      headerHeight={HEADER_HEIGHT}
      footerContent={
        <StyledFooter as={Footer}>
          <span>{`Version : ${currentVersion} `}</span>•
          {`${t('global.title')} ©${dayjs().year()} powered by `}
          <a href="https://strateg.in">Strateg.in</a>
        </StyledFooter>
      }
    />
  );
};

AdminLayout.propTypes = {
  NavMenuComponent: PropTypes.elementType
};

AdminLayout.defaultProps = {
  NavMenuComponent: AdminNavMenu
};
